import React from "react";

/**
 * Shimmer placeholder grid shown while the works are loading — mirrors the
 * WorkGridCard shape so the layout doesn't jump when data arrives.
 */
function WorkGridSkeleton({ count = 8 }) {
  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="h-full rounded-xl bg-white ring-1 ring-gray-900/5 shadow-sm overflow-hidden animate-pulse"
        >
          <div className="h-28 bg-gray-200" />
          <div className="p-4 space-y-3">
            <div className="h-2.5 w-16 rounded bg-gray-200" />
            <div className="h-3.5 w-3/4 rounded bg-gray-200" />
            <div className="h-3 w-1/2 rounded bg-gray-200" />
            <div className="flex gap-1 pt-1">
              <div className="h-5 w-10 rounded-full bg-gray-200" />
              <div className="h-5 w-12 rounded-full bg-gray-200" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default WorkGridSkeleton;
